import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Maintenance from './pages/Maintenance/Maintenance';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<Maintenance />);

